import type { TFunction } from 'i18next';

import type { SupportedLanguages } from '../../../../i18n/constants';
import type { PlayerStampCard } from '../../../../stores/stamp-card/types';

type StampCardCopyFields = Pick<PlayerStampCard, 'progressRuleType' | 'stampCount' | 'priceThreshold' | 'stampText'>;

export function getStampCardBodyCopy(card: StampCardCopyFields, language: string, t: TFunction): string {
  if (card.progressRuleType === 'SPECIFIC_PACKAGE') {
    return card.stampText?.[language as SupportedLanguages] ?? card.stampText?.EN ?? '';
  }

  if (card.priceThreshold == null) return '';

  return t('store.stampCard.tooltip.priceThresholdCopy', {
    count: card.stampCount,
    threshold: card.priceThreshold,
  });
}
